/*
 * ===============================================================================================================
 *                                Copyright 2022, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { SET_USER_FORMDATA, RESET_USER_FORMDATA } from "../types";

export const updateUserFormDataField = (name: string, value: string | any) => {
  return {
    type: SET_USER_FORMDATA,
    data: {
      [name]: value
    }
  };
};

export const updateUserFormData = (data: any) => {
  return {
    type: SET_USER_FORMDATA,
    data
  };
};

export const resetUserFormData = () => {
  return {
    type: RESET_USER_FORMDATA,
  };
};
